import { Flex, Switch, Text } from '@chakra-ui/react'

interface iProps {
  value: boolean
  isDisabled?: boolean
  id?: string
  legendaEsquerda?: string
  legendaDireita?: string
  OnChange: (e: boolean) => void
  onBlur?: () => void
  w?: string
}

export const SwitchCmp: React.FC<iProps> = ({ id, onBlur, value, legendaDireita, legendaEsquerda, OnChange, w, isDisabled }) => {
  return (
    <Flex alignItems={'center'} gap={'.625rem'} fontSize={'.875rem'} minW={w} maxW={w}>
      {legendaEsquerda && <Text color={!value ? 'var(--Azul)' : 'black'} fontWeight={!value ? '600' : ''}>{legendaEsquerda}</Text>}
      <Switch
        id={id}
        _active={{ border: 'none', boxShadow: 'none', outline: 'none' }}
        _focus={{ border: 'none', boxShadow: 'none', outline: 'none' }}
        isChecked={value}
        isDisabled={isDisabled}
        onBlur={onBlur}
        onChange={(e) => OnChange(e.target.checked)}
      />
      {legendaDireita && <Text color={value ? 'var(--Azul)' : 'black'} fontWeight={value ? '600' : ''}>{legendaDireita}</Text>}
    </Flex>
  )
}
